import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from 'contexts/auth_context/AuthContext';

export default function ProtectedRoute({ children }) {
    const { authReady, isAuth, token } = useContext(AuthContext);
    const location = useLocation();

    if (!authReady) return null;

    if (!isAuth || !token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
}
